import React, {useState, useEffect} from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import {useVsiAppContext} from "../stores/VsiApp";
import styles from "../utils/themeStyles";
import {genericColors} from "../utils/chartUtils";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

require("highcharts/indicators/indicators")(Highcharts);
require("highcharts/indicators/pivot-points")(Highcharts);
require("highcharts/indicators/macd")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/solid-gauge")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);


function ActivityGauge({series, data, includeLegend, title, height, width}) {
    const {theme, isTabletScreen} = useVsiAppContext();
    const basicTextStyle = {
        color: styles[theme].textColor,
        fontFamily: styles[theme].fontFamily,
    };

    const updateSeries = (series, data) => {
        if (series) return series;
        else if (data)
            return [
                {
                    data,
                },
            ];
        return [];
    };

    const [chartOptions, setChartOptions] = useState(
        {

            chart: {
                type: 'solidgauge',
                height: height ? height : '250',
                width: width ? width : '200',
                backgroundColor: 'transparent' || styles[theme].cardBgColor,
                ...basicTextStyle
            },
            title: {
                text: title,
                style: {
                    ...basicTextStyle,
                    fontSize: '18'
                }
            },
            tooltip: {
                borderWidth: 0,
                backgroundColor: 'none',
                shadow: false,
                yDecimal: 2,
                valueDecimals: 2,
                style: {
                    ...basicTextStyle,
                    fontSize: '16px'
                },
                valueSuffix: '%',
                pointFormat: '{series.name}' +
                    '<br><span style="font-size:2em; ' +
                    // 'color: {point.color}; ' +
                    'color: {basicTextStyle.color}; font-family: {basicTextStyle.fontFamily}' +
                    'font-weight: bold">{point.y}</span>',
            },
            legend: {
                enabled: true
            },
            pane: {
                startAngle: 0,
                endAngle: 360,
                background: [{ // Track for Move
                    outerRadius: '112%',
                    innerRadius: '88%',
                    backgroundColor: Highcharts.color(genericColors[0])
                        .setOpacity(0.3)
                        .get(),
                    borderWidth: 0
                }, { // Track for Exercise
                    outerRadius: '87%',
                    innerRadius: '63%',
                    backgroundColor: Highcharts.color(genericColors[1])
                        .setOpacity(0.3)
                        .get(),
                    borderWidth: 0
                }, { // Track for Stand
                    outerRadius: '62%',
                    innerRadius: '38%',
                    backgroundColor: Highcharts.color(genericColors[2])
                        .setOpacity(0.3)
                        .get(),
                    borderWidth: 0
                }]
            },
            mapNavigation: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            colors: ['#F62366', '#9DFF02', '#0CCDD6'],
            yAxis: {
                min: 0,
                max: 100,
                lineWidth: 0,
                tickPositions: []
            },
            // colors: ['#F62366', '#9DFF02', '#0CCDD6'],
            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        enabled: false
                    },
                    linecap: 'round',
                    stickyTracking: false,
                    rounded: true
                }
            },

            series: series
        })


    useEffect(() => {
        setChartOptions({
            ...chartOptions,
            chart: {
                ...chartOptions.chart,
            },
            title: {
                ...chartOptions.title,
                text: title,
                style: {
                    ...chartOptions.title.style,
                    ...basicTextStyle,
                }
            },
            tooltip: {
                ...chartOptions.tooltip,
                style: {
                    ...basicTextStyle,
                    fontSize: '16px'
                }
            },
            legend: {
                ...chartOptions.legend,
                itemStyle: basicTextStyle,
                align: isTabletScreen ? "right" : "center",
                enabled: includeLegend ? true : false
            },
            series: updateSeries(series, data),
        })
    }, [height, includeLegend, isTabletScreen, data, series, theme])

    return <HighchartsReact highcharts={Highcharts} options={chartOptions}/>;
}

ActivityGauge.displayName = 'ActivityGauge'

export default withErrorBoundary(ActivityGauge, GeneralErrorBoundary);
